import { InfoButton } from "@repo/ui/Buttons/infoButton";
import { Size } from "@repo/ui/helpers/helpers";
import { CenteredModal } from "@repo/ui/Modal/centeredModal";
import { ModalHeader } from "@repo/ui/Modal/modalHeader";
import type { FC } from "react";
import { Dialog, DialogTrigger } from "react-aria-components";

export interface GradingContextInfoTriggerProps {
  title: string;
  content: string;
}

/** Info icon button that opens a dialog showing grading context */
export const GradingContextInfoTrigger: FC<GradingContextInfoTriggerProps> = ({
  title,
  content,
}) => {
  return (
    <DialogTrigger>
      <InfoButton
        aria-label={`About ${title}`}
        className="opacity-0 group-hover:opacity-100 focus:opacity-100"
      />

      <CenteredModal isDismissable size={Size.LARGE}>
        <Dialog className="space-y-4 p-4 outline-hidden">
          <ModalHeader isCloseVisible>{title}</ModalHeader>
          <p className="text-sm whitespace-pre-wrap text-foreground">
            {content}
          </p>
        </Dialog>
      </CenteredModal>
    </DialogTrigger>
  );
};
